export const GENERAL_PURPOSE_SSD_GP3 = 'General Purpose SSD (gp3)';
export const DEVELOPMENT = 'development';
export const WINDOWS = 'Windows';
export const WEB_SERVER = 'Web server';
export const FRONTEND = 'frontend';
export const BUSINESS = 'business';

export default {};
